export default {
  // sales forecast
  salesForecast: "销售预测",
  salesHistory: "销售历史",
  sales: "销量",
  trend: "趋势",
  season: "季节性",
  linearRegression: "线性回归",
  forecastValue: "预测值",
  difference: "差异",
  typeInHistory: "录入销售历史数据",
  typeInForecast: "录入销售预测时间",
  coefficient: "系数",
  id: "ID",
  year: "年份",

  // cvp
  fixedCost: "固定成本",
  variableCost: "变动成本",
  totalCost: "总成本",
  totalRevenue: "总收入",
  profit: "利润",
  volume: "销量",
  amount: "金额",
  breakevenPoint: "盈亏平衡点",
  subject: "科目",
  baseNumber: "基数",
  proportion: "占比",
  adjustPercentage: "调整比例",
  adjustedAmount: "调整后金额",

  // invest decision
  assumption: "假设",
  generateEstimation: "生成预测",
  initialInvestment: "初始投资",
  pricePerUnit: "每单位价格",
  costPerUnit: "每单位成本",
  operationCostPerYear: "每年运营成本",
  initialVolume: "初始销量",
  salesGrowthRate: "销售增长率",
  years: "年数",
  depreciation: "折旧",
  amortization: "摊销",
  depreciationMethod: "折旧方法",
  straightLine: "直线法",
  accelerated: "加速折旧法",
  discountRate: "折现率",
  discountFactor: "折现因子",
  discountCashflow: "折现现金流",
  cashflow: "现金流",
  npv: "净现值",
  irr: "内部收益率",
  npvProfile: "项目净现值概况图",
};
